import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  certSubjectName: validationNotEmpty("OCSP Certificate Subject Name"),
  certIssuerSubjectName: validationNotEmpty("Issuer Subject Name"),
  ocspConfigStatus: validationNotEmpty("Status"),
});